<template>
    <div class="designer-page">
        <!-- 顶部导航栏 -->
        <!-- <Top></Top> -->

        <!-- 主要内容区域 -->
        <main class="main-content">
            <!-- 1. 设计师信息区 -->
            <section class="designer-info-section">
                <div class="designer-info-container">
                    <div class="avatar-wrapper">
                        <img :src="designerInfo.userAvatar || 'http://49.232.163.2:5159/image/30.png'" alt="设计师头像"
                            class="designer-avatar">
                    </div>
                    <div class="basic-info-wrapper">
                        <h1 class="designer-name">{{ designerInfo.userName }}</h1>
                        <p class="designer-title">{{ designerInfo.briefIntroduction }}</p>
                        <!-- <p class="designer-ip">IP：未公开</p> -->
                        <div class="action-buttons">
                            <button :class="designerInfo.follow ? 'follow-btn' : 'message-btn'" @click="handleFollow">
                                {{ designerInfo.follow ? '已关注' : '关注' }}</button>
                        </div>
                    </div>
                    <div class="stats-wrapper">
                        <div class="stats-item">
                            <p class="stats-label">作品总数</p>
                            <p class="stats-value">{{ designerInfo.publishVolume }}</p>
                        </div>
                        <div class="stats-item">
                            <p class="stats-label">累计下载</p>
                            <p class="stats-value">{{ designerInfo.downloadVolume }}</p>
                        </div>
                        <div class="stats-item">
                            <p class="stats-label">粉丝数</p>
                            <p class="stats-value">{{ designerInfo.followers }}</p>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 2. 作品列表区 -->
            <section class="works-list-section">
                <div class="works-list-container">
                    <!-- 列表标题 -->
                    <div class="works-list-header">
                        <h2 class="list-title">TA的作品</h2>
                    </div>

                    <!-- 作品网格 -->
                    <div class="works-grid">
                        <div class="work-item" v-for="(work, index) in designerInfo.modelSet" :key="index"
                            @click="goDetails(work.modelId)">
                            <div class="work-img">
                                <img :src="work.coverUrl[0]" :alt="work.title">
                            </div>
                            <div class="work-tags">
                                <span class="tag" v-for="(tag1, index1) in work.oneType" :key="index1">{{ tag1 }}</span>
                                <span class="tag" v-for="(tag2, index2) in work.twoType" :key="index2">{{ tag2 }}</span>
                                <span class="tag" v-for="(tag3, index3) in work.styleType" :key="index3">{{ tag3
                                }}</span>
                            </div>
                            <div class="work-title">{{ work.title }}</div>
                            <div class="work-info">
                                <p class="work-format">{{ work.fileFormat[0] }}</p>
                                <p class="work-price">{{ work.licensingPrices }}云币</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <!-- 底部版权区 -->
        <!-- <Bottom></Bottom> -->
    </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
    name: 'Designer',
    components: {
        Top,
        Bottom
    },
    data() {
        return {
            searchKey: '',
            isLoading: false,
            designerInfo: {
                userAvatar: "",
                userID: "",
                userName: "",
                briefIntroduction: "",
                follow: false,
                publishVolume: 0,
                downloadVolume: 0,
                followers: 0,
                modelSet: []
            },
            token: localStorage.getItem('token'),
        }
    },
    mounted() {
        // 1. 从路由获取搜索关键词
        this.searchKey = this.$route.query.id || '';

        // 2. 首次加载全部模型数据
        this.fetchAllModels();
    },
    methods: {
        // 首次加载全部模型数据
        fetchAllModels() {
            this.isLoading = true;

            // 调用接口
            this.$apiFun.getDesignerHomepage({
                userid: this.searchKey
            })
                .then(res => {
                    this.isLoading = false;

                    if (res.status === 200) {
                        // 存储全部数据并映射格式
                        this.designerInfo = res.obj;
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    console.error('加载全部模型失败:', err);
                });
        },
        async handleFollow() {
            if (this.token) {
                // 1. 判断当前状态：已关注→取消关注，未关注→关注
                const isFollow = !this.designerInfo.follow;

                try {
                    // 2. 调用后端接口
                    const res = await this.$apiFun.getAddMyInterest({ followedUser: this.designerInfo.userID });

                    // 3. 接口请求成功
                    if (res.status === 200) {
                        // 4. 同步更新页面状态
                        this.designerInfo.follow = isFollow;

                        // 5. 给用户清晰的操作反馈
                        this.$message.success(isFollow ? '关注成功！' : '取消关注成功！');
                    } else if (res.status === 401 || res.status === 0) {
                        this.$message.warning(res.msg);
                        this.$router.push('/login');
                        return;
                    } else {
                        // 6. 接口返回非成功状态
                        this.$message.error(`${isFollow ? '关注' : '取消关注'}失败：${res.message || '操作异常'}`);
                    }
                } catch (err) {
                    // 7. 捕获网络错误或接口异常
                    console.error(`${isFollow ? '关注' : '取消关注'}接口请求失败：`, err);
                    this.$message.error('网络异常，操作失败，请稍后重试');
                }
            } else {
                this.$message.warning('请先登录后再进行关注操作');
                localStorage.removeItem('userData');
                localStorage.removeItem('token');
                this.$router.push('/login');
                return;
            }
        },
        goDetails(modelId) {
            const routeInfo = this.$router.resolve({
                path: '/detail',
                query: {
                    id: modelId
                }
            });
            window.open(routeInfo.href, '_blank');
        },
    },
};
</script>

<style lang="less" scoped>
/* 基础配色变量 */
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@accent: #7c3aed;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);

/* 全局样式 - 核心响应式优化 */
.designer-page {
    width: 100%;
    /* 移除固定宽度，适配所有屏幕 */
    min-height: 100vh;
    background-color: @base-deep;
    font-family: "Microsoft YaHei", Arial, sans-serif;
    overflow-x: hidden;
    /* 防止横向溢出 */

    // 响应式断点定义
    @media screen and (max-width: 1200px) {
        padding: 0 5px;
    }

    @media screen and (max-width: 768px) {
        font-size: 14px;
    }

    @media screen and (max-width: 576px) {
        font-size: 13px;
    }
}

.main-content {
    width: 95%;
    /* 替换固定宽度为百分比 */
    max-width: 1800px;
    /* 保留最大宽度，大屏不拉伸 */
    margin: 0 auto;
    padding: 20px 0 40px;

    // 响应式调整
    @media screen and (max-width: 992px) {
        padding: 15px 0 30px;
    }

    @media screen and (max-width: 576px) {
        padding: 10px 0 20px;
        width: 98%;
    }
}

/* 设计师信息区 */
.designer-info-section {
    width: 100%;
    background-color: @base-darker;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 25px;
    margin-bottom: 30px;

    // 响应式调整
    @media screen and (max-width: 992px) {
        padding: 20px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 576px) {
        padding: 15px;
        margin-bottom: 15px;
        border-radius: 6px;
    }
}

.designer-info-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    /* 允许换行，适配小屏 */

    // 响应式调整
    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    @media screen and (max-width: 576px) {
        gap: 10px;
    }
}

.avatar-wrapper {
    position: relative;
    margin-right: 30px;
    // 优化头像容器尺寸，适配不同屏幕
    width: clamp(80px, 10vw, 150px);
    /* 最小80px，最大150px，中间按10vw自适应 */
    padding-top: clamp(80px, 10vw, 150px);
    /* 保持1:1比例 */
    border-radius: 10%;
    overflow: hidden;

    // 响应式调整
    @media screen and (max-width: 768px) {
        margin-right: 0;
        margin-bottom: 15px;
    }

    @media screen and (max-width: 576px) {
        width: clamp(60px, 15vw, 100px);
        padding-top: clamp(60px, 15vw, 100px);
        margin-bottom: 10px;
    }
}

/* 头像图片 */
.designer-avatar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border: 1px solid @base-darker;
}

.basic-info-wrapper {
    margin-right: 60px;
    flex: 1;
    /* 占剩余空间，适配布局 */
    min-width: 200px;
    /* 最小宽度，防止挤压 */

    // 响应式调整
    @media screen and (max-width: 992px) {
        margin-right: 30px;
    }

    @media screen and (max-width: 768px) {
        margin-right: 0;
        margin-bottom: 15px;
        width: 100%;
    }

    @media screen and (max-width: 576px) {
        min-width: 0;
        margin-bottom: 10px;
    }
}

.designer-name {
    font-size: clamp(18px, 2vw, 22px);
    /* 自适应字号 */
    color: #fff;
    margin: 0 0 8px;
    font-weight: 700;

    @media screen and (max-width: 576px) {
        margin-bottom: 5px;
    }
}

.designer-title {
    font-size: clamp(13px, 1.5vw, 14px);
    color: #fff;
    margin: 0 0 12px;
    line-height: 1.5;

    @media screen and (max-width: 576px) {
        margin-bottom: 8px;
    }
}

.designer-ip {
    font-size: clamp(12px, 1.3vw, 13px);
    color: #fff;
    margin: 0 0 18px;

    @media screen and (max-width: 576px) {
        margin-bottom: 12px;
    }
}

.action-buttons {
    display: flex;
    gap: 12px;

    @media screen and (max-width: 576px) {
        gap: 8px;
    }
}

.follow-btn,
.message-btn {
    width: clamp(100px, 15vw, 120px);
    /* 自适应按钮宽度 */
    height: clamp(30px, 5vw, 36px);
    /* 自适应按钮高度 */
    border-radius: 4px;
    font-size: clamp(13px, 1.5vw, 14px);
    cursor: pointer;
    transition: all 0.3s;

    // 移动端增大点击区域
    @media screen and (max-width: 576px) {
        min-height: 36px;
        min-width: 100px;
    }
}

.follow-btn {
    background-color: #1890ff;
    color: #ffffff;
    border: none;

    &:hover {
        background-color: #096dd9;
    }
}

.message-btn {
    background-color: transparent;
    color: #1890ff;
    border: 1px solid #1890ff;

    &:hover {
        background-color: #1890ff;
        color: #fff;
    }
}

.stats-wrapper {
    display: flex;
    gap: clamp(20px, 5vw, 40px);
    /* 自适应间距 */
    margin-left: auto;
    flex-wrap: wrap;
    /* 允许换行 */

    // 响应式调整
    @media screen and (max-width: 768px) {
        margin-left: 0;
        width: 100%;
        justify-content: space-between;
    }

    @media screen and (max-width: 576px) {
        gap: 10px;
        justify-content: space-around;
    }
}

.stats-item {
    text-align: center;
    min-width: 60px;
    /* 最小宽度，防止挤压 */

    @media screen and (max-width: 576px) {
        min-width: 50px;
    }
}

.stats-label {
    font-size: clamp(12px, 1.3vw, 13px);
    color: #999999;
    margin: 0 0 5px;
}

.stats-value {
    font-size: clamp(16px, 1.8vw, 18px);
    color: #fff;
    margin: 0;
    font-weight: 700;
}

/* 作品列表区 */
.works-list-section {
    width: 100%;
    background-color: @base-darker;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 25px;

    // 响应式调整
    @media screen and (max-width: 992px) {
        padding: 20px;
    }

    @media screen and (max-width: 576px) {
        padding: 15px;
        border-radius: 6px;
    }
}

.works-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    @media screen and (max-width: 576px) {
        margin-bottom: 15px;
    }
}

.list-title {
    font-size: clamp(16px, 1.8vw, 18px);
    color: #fff;
    margin: 0;
    font-weight: 700;
}

.works-grid {
    display: flex;
    flex-wrap: wrap;
    gap: clamp(10px, 2vw, 18px);
    /* 自适应间距 */

    // 修复网格计算问题，适配不同屏幕
    @media screen and (max-width: 1200px) {
        gap: clamp(8px, 1.5vw, 15px);
    }
}

.work-item {
    // 优化作品项宽度计算，适配不同屏幕
    width: calc((100% - (4 * clamp(10px, 2vw, 18px))) / 5);
    border-radius: 6px;
    overflow: hidden;
    transition: box-shadow 0.3s;
    cursor: pointer;

    // 响应式调整 - 大屏5列 → 中屏3列 → 小屏2列 → 超小屏1列
    @media screen and (max-width: 1400px) {
        width: calc((100% - (3 * clamp(10px, 2vw, 18px))) / 4);
    }

    @media screen and (max-width: 1200px) {
        width: calc((100% - (2 * clamp(8px, 1.5vw, 15px))) / 3);
    }

    @media screen and (max-width: 768px) {
        width: calc((100% - (1 * clamp(8px, 1.5vw, 15px))) / 2);
    }

    @media screen and (max-width: 480px) {
        width: 100%;
    }

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    }
}

.work-img {
    width: 100%;
    height: clamp(120px, 20vw, 180px);
    /* 自适应高度 */
    overflow: hidden;

    @media screen and (max-width: 768px) {
        height: clamp(100px, 25vw, 150px);
    }

    @media screen and (max-width: 480px) {
        height: clamp(150px, 30vw, 200px);
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s;
    }
}

.work-item:hover .work-img img {
    transform: scale(1.05);
}

.work-tags {
    padding: clamp(8px, 1.5vw, 12px);
    display: flex;
    flex-wrap: wrap;
    gap: clamp(4px, 1vw, 6px);

    @media screen and (max-width: 576px) {
        padding: 8px;
        gap: 4px;
    }
}

.tag {
    font-size: clamp(11px, 1.2vw, 12px);
    color: #999;
    background-color: rgba(255, 255, 255, 0.1);
    padding: clamp(2px, 0.5vw, 2px) clamp(6px, 1vw, 8px);
    border-radius: 4px;

    @media screen and (max-width: 576px) {
        font-size: 11px;
        padding: 2px 6px;
    }
}

.work-title {
    color: #fff;
    padding: 0 clamp(8px, 1.5vw, 12px) clamp(8px, 1.5vw, 12px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: clamp(12px, 1.3vw, 14px);

    @media screen and (max-width: 576px) {
        padding: 0 8px 8px;
    }
}

.work-info {
    padding: 0 clamp(8px, 1.5vw, 12px) clamp(8px, 1.5vw, 12px);
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 576px) {
        padding: 0 8px 8px;
    }
}

.work-format {
    font-size: clamp(12px, 1.3vw, 13px);
    color: #999999;
    margin: 0;
}

.work-price {
    font-size: clamp(13px, 1.4vw, 14px);
    color: #ff4d4f;
    margin: 0;
    font-weight: 700;
}

/* 补充：移动端交互优化 */
@media screen and (max-width: 576px) {

    // 增大可点击区域
    .work-item {
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    // 优化滚动体验
    .main-content {
        -webkit-overflow-scrolling: touch;
    }
}
</style>